exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-direction-bottom-right{width:30%!important}.mrgtop-2per{margin-top:1%}.mrgtop-5px{margin-top:0}.center{text-align:center}.heght-1px{height:1px}.b-form-input-container{margin:4px 0 12px!important}.md-button-color{background-color:#607d8d!important}.md-button-color-toggle{background-color:hsla(0,0%,60%,.4)!important}.activeClass{display:none}.error{color:red}.navbar-brand{height:auto}@media only screen and (min-width:320px) and (max-width:766px){.mobile-btn{margin-right:13px}.navbar-dark .navbar-brand.mobile-font{font-size:15px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-04637de8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/allModuleForm/viewDeleteRequestAllModuleDetails.vue
// module id = 1349
// module chunks = 0